import React from 'react';

import StyledComponent from '~/components/Styled/Styled';
import ResultsMatchupDescriptionCard from '~/components/ResultsMatchupDescriptionCard/ResultsMatchupDescriptionCard';
import RacingResultsMatchupCard from '~/components/ResultsMatchupCard/RacingResultsMatchupCard/RacingResultsMatchupCard';
import MMAResultsMatchupCard from '~/components/ResultsMatchupCard/MMAResultsMatchupCard/MMAResultsMatchupCard';
import TennisResultsMatchupCard from '~/components/ResultsMatchupCard/TennisResultsMatchupCard/TennisResultsMatchupCard';

import getOr from '~/util/getOr';

import css from './ResultsMatchupCard.scss';

type Props = {
  event: any;
  eventRecords: any;
};

class ResultsMatchupCard extends React.Component<Props> {
  static displayName = 'ResultsMatchupCard';

  renderMatchupRecords() {
    const leagueSlug = getOr(this.props, 'event.league.slug', '');
    const { event, eventRecords } = this.props;
    if (!eventRecords) {
      return null;
    }

    switch (leagueSlug) {
      case 'nascar':
      case 'formula1':
        return <RacingResultsMatchupCard event={event} eventRecords={eventRecords} />;
      case 'mma':
        return <MMAResultsMatchupCard event={event} eventRecords={eventRecords} />;
      case 'atp':
      case 'wta':
        return <TennisResultsMatchupCard event={event} eventRecords={eventRecords} />;
      default:
        return (
          <div className={css.pregameNoticeContainer}>
            <div className={css.preGameNoticeText1}>Event hasn&apos;t started yet</div>
            <div className={css.preGameNoticeText2}>Please check back later for more details</div>
          </div>
        );
    }
  }

  render() {
    return (
      <div className={css.resultMatchupCardContainer}>
        <ResultsMatchupDescriptionCard event={this.props.event} />
        {this.renderMatchupRecords()}
      </div>
    );
  }
}

export default StyledComponent(ResultsMatchupCard, [css]);
